import * as t from 'io-ts';

import {RPatchTeamPreferencesTeammateError} from '../../../models/api/patchTeamPreferencesModel';
import {PanelTypesEnum, RInboxesPanelId, RPanelStateBase} from '../panelStateBase';
import {RInboxesParameters} from './parameters/inboxesParameters';

/*
 * Runtime types.
 */

export const RInboxesPanelStateDirty = t.intersection([
  RPanelStateBase,
  t.type({
    id: RInboxesPanelId,
    type: t.literal(PanelTypesEnum.INBOXES),
    parameters: RInboxesParameters,
    isEditingWorkspaces: t.boolean,
    pinTagBannerErrors: t.readonlyArray(RPatchTeamPreferencesTeammateError),
    isSearchQueryBuilderDropdownOpen: t.boolean,
  }),
]);

/*
 * Types.
 */

export interface InboxesPanelState extends Readonly<t.TypeOf<typeof RInboxesPanelStateDirty>> {}
export const RInboxesPanelState = t.clean<InboxesPanelState>(RInboxesPanelStateDirty as any);
